import React from 'react'
import classNames from 'classnames'

const Tab = ({ label, index, currentTabIndex, hasAlert, switchTab }) => {
  const badgeCount = typeof hasAlert === 'number' ? hasAlert : null
  const showBadge = badgeCount !== null && badgeCount > 0

  const classes = classNames(
    'tab', {
      'active': index === currentTabIndex,
      // Boolean/string alerts keep the simple dot; a numeric alert renders a count badge instead.
      'alert-indicator': hasAlert && !showBadge
    }
  )

  return (
    <div
      className={classes}
      onClick={() => switchTab(index)}
      title={typeof hasAlert === 'string' ? hasAlert : undefined}
    >
      {label}
      {showBadge &&
        <span className='tab__badge'>{badgeCount > 99 ? '99+' : badgeCount}</span>
      }
    </div>
  )
}

export default Tab
